interface IProps {
    id: string;
    color: string;
    width: string;
    height: string;
  }
  
  const IceCreamWidget = ({id, color, width, height}: IProps) => {
    return <svg id={id} version="1.0" xmlns="http://www.w3.org/2000/svg"
      width={width} height={height} viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet">
   
        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
          fill={color} stroke="none">
          <path d="M2523 4599 c-6 -8 -14 -34 -18 -59 -17 -101 -87 -195 -182 -243 -26
            -14 -88 -37 -138 -52 -124 -37 -220 -89 -286 -155 -66 -66 -95 -118 -107 -193
            -14 -87 1 -171 45 -258 l40 -76 -69 -13 c-92 -16 -195 -69 -248 -126 -63 -69
            -83 -122 -88 -235 -6 -148 29 -248 125 -350 l43 -46 -31 -22 c-42 -31 -54 -67
            -69 -198 -12 -103 -11 -114 6 -150 11 -21 35 -48 54 -61 38 -25 33 -5 70 -265
            15 -107 45 -150 117 -170 31 -8 45 -17 48 -32 2 -11 29 -295 60 -632 30 -337
            60 -625 66 -640 14 -38 57 -83 96 -99 47 -20 959 -20 1006 0 39 16 82 61 96
            99 6 16 36 304 67 640 30 337 57 622 59 633 4 15 15 24 40 28 41 8 93 49 106
            84 6 14 21 96 34 181 13 86 29 157 35 159 27 9 70 56 80 88 9 27 9 60 0 137
            -14 126 -24 158 -55 187 l-25 24 38 40 c85 89 116 178 110 310 -3 76 -9 102
            -34 156 -17 36 -46 83 -65 105 -43 49 -134 108 -192 124 l-44 13 19 61 c25 80
            20 197 -11 280 -46 117 -184 228 -307 245 l-49 7 -6 101 c-4 84 -10 111 -34
            160 -61 126 -188 213 -320 222 -52 3 -74 1 -82 -9z m916 -1918 c18 -12 42
            -192 29 -216 -8 -13 -109 -15 -908 -15 -799 0 -900 2 -908 15 -13 24 11 204
            29 216 8 5 372 9 879 9 507 0 871 -4 879 -9z m-69 -353 c0 -7 -9 -71 -20 -143
            -23 -145 -28 -155 -96 -155 -36 0 -74 -18 -74 -36 0 -2 -27 -297 -60 -655 -33
            -358 -60 -655 -60 -660 0 -6 -11 -21 -25 -34 l-24 -25 -451 0 -451 0 -24 25
            c-14 13 -25 29 -25 35 0 5 -25 278 -55 605 -30 328 -55 605 -55 615 0 20 10
            20 494 20 538 0 526 -1 526 55 0 57 18 55 -589 55 -430 0 -561 3 -574 13 -12
            9 -22 50 -37 150 -11 76 -20 140 -20 143 0 2 365 4 810 4 641 0 810 -3 810
            -12z"/>
        </g>
      </svg>
  }
  
  export default IceCreamWidget;